<script
  setup
  lang="ts"
  generic="SelectOption extends Record<string, any>, OptionValue extends keyof SelectOption"
>
const props = defineProps<{
  name: string
  selectOptions?: SelectOption[]
  optionKey: keyof SelectOption
  optionName: keyof SelectOption
  /**Key of the select option to bind to the component value. Leave blank to bind the entire object */
  optionValue?: OptionValue // TODO = Remove this. The value will be the full SelectOption
  /**If true, will allow the selection of a blank option with value = null */
  allowBlank?: boolean
}>()
const modelValue = defineModel<SelectOption[OptionValue] | null>()
defineOptions({ inheritAttrs: false })
</script>

<template>
  <div class="flex flex-col">
    <label :for="props.name" class="mb-2 block text-sm font-medium">{{ props.name }}</label>
    <div class="block w-full rounded-lg border border-gray-300 bg-gray-50 text-sm text-gray-900">
      <select
        class="h-full w-full p-2.5 focus:border-blue-500 focus:ring-blue-500"
        v-model="modelValue"
        v-bind="$attrs"
        :name="props.name"
        :id="props.name"
      >
        <option v-if="props.allowBlank" :value="null"></option>
        <option
          :value="props.optionValue ? option[props.optionValue] : option"
          :key="option[props.optionKey]"
          v-for="option in props.selectOptions"
        >
          {{ option[props.optionName] }}
        </option>
      </select>
    </div>
  </div>
</template>
